import { render } from "./RelacionUsuarioPerfilRegistro.vue?vue&type=template&id=d4cad89c"
import script from "./RelacionUsuarioPerfilRegistro.vue?vue&type=script&lang=js"
export * from "./RelacionUsuarioPerfilRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__